export default "<p>\n  redirecionando do software para a tela de sinais ...\n</p>\n"